<template>
  <div class="tab-pane-inner tab-pane-business">
    <draggable
      v-model="orderSync"
      class="biz-flow-draggable"
      handle=".biz-section-drag-handle"
      :animation="200"
      ghost-class="biz-flow-ghost"
      chosen-class="biz-flow-chosen"
    >
      <div v-for="sectionKey in flowSectionOrder" :key="sectionKey">
        <div
          v-if="isRolePersonaSectionKey(sectionKey)"
          class="biz-flow-card biz-flow-card--custom config-card config-card-collapsible"
        >
          <div
            class="biz-section-head biz-section-head--custom"
            @click="onSectionHeadToggle(sectionKey, $event)"
          >
            <span class="biz-section-drag-handle" title="拖拽排序">
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
            </span>
            <span
              class="biz-section-icon-btn biz-section-toggle-btn"
              :title="expanded[sectionKey] ? '收起' : '展开'"
            >
              <Icon
                :type="expanded[sectionKey] ? 'ios-arrow-down' : 'ios-arrow-forward'"
                size="14"
              />
            </span>
            <Input
              v-if="fixedTitleShowInput[sectionKey]"
              :ref="(el) => setFixedTitleInputRef(sectionKey, el)"
              v-model="flowSectionTitles[sectionKey]"
              class="biz-custom-title-input"
              placeholder="请输入标题"
              :maxlength="40"
              @on-blur="() => finishFixedTitleEdit(sectionKey)"
              @on-enter="() => finishFixedTitleEdit(sectionKey)"
            />
            <div v-else class="biz-custom-title-display biz-section-title-plain">
              <span class="biz-fixed-title-text">{{ getRolePersonaSectionTitle() }}</span>
            </div>
            <div class="biz-section-actions">
              <span
                class="biz-section-icon-btn biz-section-icon-btn--edit"
                title="编辑标题"
                @click="startFixedTitleEdit(sectionKey)"
              >
                <EditOutlinedIcon :size="16" />
              </span>
              <span class="biz-section-vdivider" />
              <Poptip
                :value="exclusiveConfirmKey === 'biz-section-' + sectionKey"
                confirm
                placement="top-end"
                transfer
                :title="clearFlowConfirmTitle(sectionKey)"
                ok-text="确定"
                cancel-text="取消"
                @click.native.stop
                @input="onExclusiveConfirmInput('biz-section-' + sectionKey, $event)"
                @on-ok="executeClearFlowSection(sectionKey)"
              >
                <span class="biz-flow-trash-trigger">
                  <DeleteIconButton size="sm" title="清空该模块" />
                </span>
              </Poptip>
            </div>
          </div>
          <div v-show="expanded[sectionKey]" class="card-body-inner card-body-inner--role">
            <LlmRolePersonaPanel :form="form" :memory-enabled="memoryEnabled" />
          </div>
        </div>
        <div
          v-else-if="isCustomFlowKey(sectionKey)"
          class="biz-flow-card biz-flow-card--custom config-card config-card-collapsible"
        >
          <div
            class="biz-section-head biz-section-head--custom"
            @click="onSectionHeadToggle(sectionKey, $event)"
          >
            <span class="biz-section-drag-handle" title="拖拽排序">
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
            </span>
            <span
              class="biz-section-icon-btn biz-section-toggle-btn"
              :title="expanded[sectionKey] ? '收起' : '展开'"
            >
              <Icon
                :type="expanded[sectionKey] ? 'ios-arrow-down' : 'ios-arrow-forward'"
                size="14"
              />
            </span>
            <Input
              v-if="getCustomRow(sectionKey) && customTitleShowInput[sectionKey] === true"
              :ref="(el) => setCustomTitleInputRef(sectionKey, el)"
              v-model="getCustomRow(sectionKey).title"
              class="biz-custom-title-input"
              placeholder="请输入标题"
              :maxlength="80"
              @on-blur="() => finishCustomTitleEdit(sectionKey)"
              @on-enter="() => finishCustomTitleEdit(sectionKey)"
            />
            <span
              v-else-if="getCustomRow(sectionKey)"
              class="biz-custom-title-display biz-section-title-plain"
              :class="{ 'is-empty': !String(getCustomRow(sectionKey).title || '').trim() }"
            >
              <span class="biz-title-text">{{ customTitleDisplayText(sectionKey) }}</span>
            </span>
            <div class="biz-section-actions">
              <span
                class="biz-section-icon-btn biz-section-icon-btn--edit"
                title="编辑标题"
                @click="startCustomTitleEdit(sectionKey)"
              >
                <EditOutlinedIcon :size="16" />
              </span>
              <span class="biz-section-vdivider" />
              <Poptip
                :value="exclusiveConfirmKey === 'biz-section-' + sectionKey"
                confirm
                placement="top-end"
                transfer
                :title="clearFlowConfirmTitle(sectionKey)"
                ok-text="确定"
                cancel-text="取消"
                @click.native.stop
                @input="onExclusiveConfirmInput('biz-section-' + sectionKey, $event)"
                @on-ok="executeClearFlowSection(sectionKey)"
              >
                <span class="biz-flow-trash-trigger">
                  <DeleteIconButton size="sm" title="删除该模块" />
                </span>
              </Poptip>
            </div>
          </div>
          <div v-show="expanded[sectionKey]" class="card-body-inner">
            <div v-if="isFlowGuideVisible(sectionKey)" class="role-desc-guide">
              <div
                class="role-desc-guide__bar"
                role="button"
                tabindex="0"
                @click="toggleFlowGuideExpanded(sectionKey)"
                @keyup.enter="toggleFlowGuideExpanded(sectionKey)"
              >
                <span class="role-desc-guide__bar-title">配置指引</span>
                <a
                  href="javascript:void(0)"
                  class="role-desc-guide__toggle"
                  @click.stop="toggleFlowGuideExpanded(sectionKey)"
                >{{ flowGuideExpanded[sectionKey] ? '收起示例' : '查看示例' }}</a>
              </div>
              <div v-show="flowGuideExpanded[sectionKey]" class="role-desc-guide__panel">
                <p
                  v-if="getFlowGuideSuggestion(sectionKey).trim()"
                  class="role-desc-guide__p role-desc-guide__p--pre"
                >
                  <span class="role-desc-guide__label">建议：</span>
                  {{ getFlowGuideSuggestion(sectionKey) }}
                </p>
                <p
                  v-if="getFlowGuideExample(sectionKey).trim()"
                  class="role-desc-guide__p role-desc-guide__p--pre"
                >
                  <span class="role-desc-guide__label">例如：</span>
                  {{ getFlowGuideExample(sectionKey) }}
                </p>
              </div>
            </div>
            <LlmTextareaWithInsertParam
              v-if="getCustomRow(sectionKey)"
              :ref="(el) => setBizInputRef(sectionKey, el)"
              v-model="getCustomRow(sectionKey).body"
              :rows="8"
              placeholder="请输入内容"
              :maxlength="customSectionBodyMax"
              :customer-info-params="form.customerInfoParams"
              :memory-enabled="memoryEnabled"
            />
          </div>
        </div>
        <div v-else class="biz-flow-card biz-flow-card--custom config-card config-card-collapsible">
          <div
            class="biz-section-head biz-section-head--custom"
            @click="onSectionHeadToggle(sectionKey, $event)"
          >
            <span class="biz-section-drag-handle" title="拖拽排序">
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
              <span class="biz-section-drag-dot" />
            </span>
            <span
              class="biz-section-icon-btn biz-section-toggle-btn"
              :title="expanded[sectionKey] ? '收起' : '展开'"
            >
              <Icon
                :type="expanded[sectionKey] ? 'ios-arrow-down' : 'ios-arrow-forward'"
                size="14"
              />
            </span>
            <Input
              v-if="fixedTitleShowInput[sectionKey]"
              :ref="(el) => setFixedTitleInputRef(sectionKey, el)"
              v-model="flowSectionTitles[sectionKey]"
              class="biz-custom-title-input"
              placeholder="请输入标题"
              :maxlength="40"
              @on-blur="() => finishFixedTitleEdit(sectionKey)"
              @on-enter="() => finishFixedTitleEdit(sectionKey)"
            />
            <div v-else class="biz-custom-title-display biz-fixed-title-row biz-section-title-plain">
              <span class="biz-fixed-title-inner">
                <span class="biz-fixed-title-text">{{ getFixedSectionTitle(sectionKey) }}</span>
                <Tooltip
                  v-if="sectionKey === 'opening'"
                  content="首次进入对话时，AI客服主动向访问者打招呼语，未填写时由大模型生成。"
                  placement="right"
                  :max-width="500"
                  transfer-class-name="biz-opening-tooltip"
                >
                  <Icon
                    type="ios-information-circle-outline"
                    size="16"
                    class="info-icon biz-fixed-title-info-icon"
                    @click.stop
                  />
                </Tooltip>
              </span>
            </div>
            <div class="biz-section-actions">
              <span
                class="biz-section-icon-btn biz-section-icon-btn--edit"
                title="编辑标题"
                @click="startFixedTitleEdit(sectionKey)"
              >
                <EditOutlinedIcon :size="16" />
              </span>
              <span class="biz-section-vdivider" />
              <Poptip
                :value="exclusiveConfirmKey === 'biz-section-' + sectionKey"
                confirm
                placement="top-end"
                transfer
                :title="clearFlowConfirmTitle(sectionKey)"
                ok-text="确定"
                cancel-text="取消"
                @click.native.stop
                @input="onExclusiveConfirmInput('biz-section-' + sectionKey, $event)"
                @on-ok="executeClearFlowSection(sectionKey)"
              >
                <span class="biz-flow-trash-trigger">
                  <DeleteIconButton size="sm" title="删除" />
                </span>
              </Poptip>
            </div>
          </div>
          <div v-show="expanded[sectionKey]" class="card-body-inner">
            <div v-if="isFlowGuideVisible(sectionKey)" class="role-desc-guide">
              <div
                class="role-desc-guide__bar"
                role="button"
                tabindex="0"
                @click="toggleFlowGuideExpanded(sectionKey)"
                @keyup.enter="toggleFlowGuideExpanded(sectionKey)"
              >
                <span class="role-desc-guide__bar-title">配置指引</span>
                <a
                  href="javascript:void(0)"
                  class="role-desc-guide__toggle"
                  @click.stop="toggleFlowGuideExpanded(sectionKey)"
                >{{ flowGuideExpanded[sectionKey] ? '收起示例' : '查看示例' }}</a>
              </div>
              <div v-show="flowGuideExpanded[sectionKey]" class="role-desc-guide__panel">
                <p
                  v-if="getFlowGuideSuggestion(sectionKey).trim()"
                  class="role-desc-guide__p role-desc-guide__p--pre"
                >
                  <span class="role-desc-guide__label">建议：</span>
                  {{ getFlowGuideSuggestion(sectionKey) }}
                </p>
                <p
                  v-if="getFlowGuideExample(sectionKey).trim()"
                  class="role-desc-guide__p role-desc-guide__p--pre"
                >
                  <span class="role-desc-guide__label">例如：</span>
                  {{ getFlowGuideExample(sectionKey) }}
                </p>
              </div>
            </div>
            <template v-if="sectionKey === 'intentTag'">
              <div
                v-for="(rule, index) in intentTag.rules"
                :key="index"
                class="form-row"
                style="align-items: flex-start"
              >
                <div class="intent-rule-row">
                  <Input
                    v-model="rule.name"
                    placeholder="请输入意向名称"
                    style="width: 200px; margin-right: 12px"
                  />
                  <Input
                    v-model="rule.rule"
                    type="textarea"
                    :rows="1"
                    placeholder="请输入对应规则"
                    style="flex: 1"
                    :maxlength="1000"
                    show-word-limit
                  />
                  <Poptip
                    :value="exclusiveConfirmKey === 'biz-intent-rule-' + index"
                    confirm
                    placement="top-end"
                    transfer
                    :title="intentRuleDeleteConfirmTitle(rule)"
                    ok-text="确定"
                    cancel-text="取消"
                    @click.native.stop
                    @input="onExclusiveConfirmInput('biz-intent-rule-' + index, $event)"
                    @on-ok="removeIntentRule(index)"
                  >
                    <span class="biz-flow-trash-trigger biz-flow-trash-trigger--intent-rule">
                      <DeleteIconButton size="sm" title="删除" />
                    </span>
                  </Poptip>
                </div>
              </div>
              <div class="form-row" style="justify-content: center">
                <Button type="dashed" icon="md-add" @click="addIntentRule">新增意向标签</Button>
              </div>
            </template>
            <template v-else-if="flowSectionMeta[sectionKey]">
              <LlmTextareaWithInsertParam
                v-if="flowSectionMeta[sectionKey].insertParam !== false"
                :ref="(el) => setBizInputRef(sectionKey, el)"
                v-model="form[sectionKey]"
                :rows="flowSectionMeta[sectionKey].rows"
                :placeholder="flowSectionMeta[sectionKey].placeholder"
                :maxlength="flowSectionMeta[sectionKey].maxlength"
                :customer-info-params="form.customerInfoParams"
                :memory-enabled="memoryEnabled"
              />
              <Input
                v-else
                :ref="(el) => setBizInputRef(sectionKey, el)"
                v-model="form[sectionKey]"
                type="textarea"
                :rows="flowSectionMeta[sectionKey].rows"
                :placeholder="flowSectionMeta[sectionKey].placeholder"
                :maxlength="flowSectionMeta[sectionKey].maxlength"
                show-word-limit
              />
            </template>
          </div>
        </div>
      </div>
    </draggable>

    <div class="llm-flow-add-wrap">
      <Button type="default" class="llm-flow-add-btn" @click="addFlowContent">
        <Icon type="md-add" />
        增加内容
      </Button>
    </div>

    <div id="llm-final-prompt-preview" class="biz-flow-card llm-prompt-preview-card">
      <div class="biz-section-head llm-prompt-preview-head" @click="togglePromptPreview">
        <span class="llm-prompt-preview-head-left">
          <Icon type="ios-eye" size="18" />
          <span>最终提示词预览</span>
        </span>
        <div class="biz-section-actions">
          <span
            class="llm-prompt-preview-count"
            :class="{ 'is-over': mergedFlowPromptLength > mergedFlowPromptLimit }"
          >{{ mergedFlowPromptLength }}/{{ mergedFlowPromptLimit }}</span>
          <span
            class="biz-section-icon-btn biz-section-toggle-btn"
            :title="expanded.promptPreview ? '收起' : '展开'"
          >
            <Icon
              :type="expanded.promptPreview ? 'ios-arrow-down' : 'ios-arrow-forward'"
              size="14"
            />
          </span>
        </div>
      </div>
      <div v-show="expanded.promptPreview" class="llm-prompt-preview-body">
        <textarea
          class="llm-prompt-preview-native"
          readonly
          rows="18"
          :value="mergedFlowPromptMarkdown"
          placeholder="角色与人设与业务模块填写后，将在此处合并展示（按拖拽顺序，## 标题）…"
        />
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import {
  FLOW_SECTION_META,
  CUSTOM_FLOW_PREFIX,
  CUSTOM_SECTION_BODY_MAX,
  ROLE_PERSONA_META,
} from '../../constants/flowSection'
import * as Fsh from '../../utils/flowSectionHelpers'
import TextareaWithInsertParam from '../shared/TextareaWithInsertParam.vue'
import EditOutlinedIcon from '../shared/EditOutlinedIcon.vue'
import DeleteIconButton from '../shared/DeleteIconButton.vue'
import LlmRolePersonaPanel from '../role-persona/index.vue'
import { exclusiveConfirmMixin } from '../../utils/exclusiveConfirm'

export default {
  name: 'LlmBusinessFlowTab',
  mixins: [exclusiveConfirmMixin],
  components: {
    draggable,
    LlmTextareaWithInsertParam: TextareaWithInsertParam,
    LlmRolePersonaPanel,
    EditOutlinedIcon,
    DeleteIconButton,
  },
  props: {
    form: { type: Object, required: true },
    flowSectionOrder: { type: Array, required: true },
    customFlowSections: { type: Array, required: true },
    flowSectionTitles: { type: Object, required: true },
    expanded: { type: Object, required: true },
    flowGuideExpanded: { type: Object, required: true },
    fixedTitleShowInput: { type: Object, required: true },
    customTitleShowInput: { type: Object, required: true },
    intentTag: { type: Object, required: true },
    getRoleInfoTextForPrompt: { type: Function, required: true },
    memoryEnabled: { type: Boolean, default: false },
  },
  data() {
    return {
      bizInputRefs: {},
      fixedTitleInputRefs: {},
      customTitleInputRefs: {},
    }
  },
  computed: {
    flowSectionMeta() {
      return FLOW_SECTION_META
    },
    customSectionBodyMax() {
      return CUSTOM_SECTION_BODY_MAX
    },
    orderSync: {
      get() {
        return this.flowSectionOrder
      },
      set(val) {
        this.$emit('update:flowSectionOrder', val)
      },
    },
    mergedFlowPromptMarkdown() {
      const parts = []
      const freePromptTrim =
        this.form.customPrompt != null ? String(this.form.customPrompt).trim() : ''
      if (freePromptTrim) {
        parts.push(`## 自由模式\n\n${freePromptTrim}`)
      }
      for (const key of this.flowSectionOrder) {
        if (Fsh.isRolePersonaSectionKey(key)) {
          const heading = this.getRolePersonaSectionTitle()
          const roleInfoText = this.getRoleInfoTextForPrompt()
          const roleDescTrim = this.form.roleDesc != null ? String(this.form.roleDesc).trim() : ''
          const bodyParts = []
          if (roleInfoText != null && String(roleInfoText).trim()) {
            bodyParts.push(String(roleInfoText).trim())
          }
          if (roleDescTrim) bodyParts.push(roleDescTrim)
          if (!bodyParts.length) continue
          parts.push(`## ${heading}\n\n${bodyParts.join('\n\n')}`)
          continue
        }
        if (Fsh.isCustomFlowKey(key)) {
          const row = Fsh.getCustomRow(this.customFlowSections, key)
          if (!row) continue
          const title = String(row.title || '').trim() || '自定义'
          const body = String(row.body || '').trim()
          if (!title && !body) continue
          if (body) parts.push(`## ${title}\n\n${body}`)
          else parts.push(`## ${title}`)
          continue
        }
        const meta = FLOW_SECTION_META[key]
        if (!meta || !meta.promptTitle) continue
        const raw = Fsh.getFlowSectionPromptValue(this.form, this.intentTag, key)
        const val = raw != null ? String(raw).trim() : ''
        if (!val) continue
        const heading = Fsh.getFixedSectionTitle(this.flowSectionTitles, key)
        parts.push(`## ${heading}\n\n${val}`)
      }
      return parts.join('\n\n')
    },
    mergedFlowPromptLength() {
      return this.mergedFlowPromptMarkdown.length
    },
    mergedFlowPromptLimit() {
      return 40000
    },
  },
  methods: {
    isRolePersonaSectionKey(k) {
      return Fsh.isRolePersonaSectionKey(k)
    },
    getRolePersonaSectionTitle() {
      const custom = this.flowSectionTitles[Fsh.ROLE_PERSONA_SECTION_KEY]
      if (custom != null && String(custom).trim() !== '') return String(custom).trim()
      return ROLE_PERSONA_META.title
    },
    toggleExpanded(sectionKey) {
      this.$set(this.expanded, sectionKey, !this.expanded[sectionKey])
    },
    onSectionHeadToggle(sectionKey, event) {
      const target = event && event.target
      if (!target || !target.closest) return
      if (target.closest('.biz-section-drag-handle')) return
      if (target.closest('.biz-section-actions')) return
      if (target.closest('.biz-custom-title-input')) return
      if (target.closest('.biz-fixed-title-info-icon')) return
      if (target.closest('.ivu-tooltip')) return
      this.toggleExpanded(sectionKey)
    },
    togglePromptPreview() {
      this.$set(this.expanded, 'promptPreview', !this.expanded.promptPreview)
    },
    isCustomFlowKey(k) {
      return Fsh.isCustomFlowKey(k)
    },
    getCustomRow(sectionKey) {
      return Fsh.getCustomRow(this.customFlowSections, sectionKey)
    },
    getFixedSectionTitle(key) {
      return Fsh.getFixedSectionTitle(this.flowSectionTitles, key)
    },
    setBizInputRef(key, el) {
      if (el) {
        this.$set(this.bizInputRefs, key, el)
      } else if (this.bizInputRefs[key]) {
        this.$delete(this.bizInputRefs, key)
      }
    },
    setCustomTitleInputRef(key, el) {
      if (el) {
        this.$set(this.customTitleInputRefs, key, el)
      } else if (this.customTitleInputRefs[key]) {
        this.$delete(this.customTitleInputRefs, key)
      }
    },
    setFixedTitleInputRef(key, el) {
      if (el) {
        this.$set(this.fixedTitleInputRefs, key, el)
      } else if (this.fixedTitleInputRefs[key]) {
        this.$delete(this.fixedTitleInputRefs, key)
      }
    },
    startFixedTitleEdit(key) {
      if (Fsh.isRolePersonaSectionKey(key)) {
        if (this.flowSectionTitles[key] === undefined) {
          this.$set(this.flowSectionTitles, key, ROLE_PERSONA_META.title)
        }
      } else if (this.flowSectionTitles[key] === undefined) {
        this.$set(this.flowSectionTitles, key, FLOW_SECTION_META[key].title)
      }
      this.$set(this.fixedTitleShowInput, key, true)
      this.$nextTick(() => {
        const c = this.fixedTitleInputRefs[key]
        if (!c) return
        if (typeof c.focus === 'function') {
          c.focus()
        } else if (c.$refs && c.$refs.input && typeof c.$refs.input.focus === 'function') {
          c.$refs.input.focus()
        }
      })
    },
    finishFixedTitleEdit(key) {
      let v = this.flowSectionTitles[key]
      if (v != null) v = String(v).trim()
      const def = Fsh.isRolePersonaSectionKey(key)
        ? ROLE_PERSONA_META.title
        : FLOW_SECTION_META[key].title
      if (!v || v === def) {
        this.$delete(this.flowSectionTitles, key)
      } else {
        this.$set(this.flowSectionTitles, key, v)
      }
      this.$set(this.fixedTitleShowInput, key, false)
    },
    finishCustomTitleEdit(key) {
      this.$set(this.customTitleShowInput, key, false)
    },
    startCustomTitleEdit(key) {
      this.$set(this.customTitleShowInput, key, true)
      this.$nextTick(() => {
        const c = this.customTitleInputRefs[key]
        if (!c) return
        if (typeof c.focus === 'function') {
          c.focus()
        } else if (c.$refs && c.$refs.input && typeof c.$refs.input.focus === 'function') {
          c.$refs.input.focus()
        }
      })
    },
    customTitleDisplayText(key) {
      const row = this.getCustomRow(key)
      const t = row && String(row.title || '').trim()
      return t || '请输入标题'
    },
    isFlowGuideVisible(sectionKey) {
      const meta = FLOW_SECTION_META[sectionKey]
      if (!meta || meta.isShowGuide === false) return false
      const s = meta.guideSuggestion != null ? String(meta.guideSuggestion).trim() : ''
      const e = meta.guideExample != null ? String(meta.guideExample).trim() : ''
      return !!(s || e)
    },
    toggleFlowGuideExpanded(sectionKey) {
      const cur = !!this.flowGuideExpanded[sectionKey]
      this.$set(this.flowGuideExpanded, sectionKey, !cur)
    },
    getFlowGuideSuggestion(sectionKey) {
      const meta = FLOW_SECTION_META[sectionKey]
      return meta && meta.guideSuggestion != null ? String(meta.guideSuggestion) : ''
    },
    getFlowGuideExample(sectionKey) {
      const meta = FLOW_SECTION_META[sectionKey]
      return meta && meta.guideExample != null ? String(meta.guideExample) : ''
    },
    addFlowContent() {
      const id = `c_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`
      const key = `${CUSTOM_FLOW_PREFIX}${id}`
      this.customFlowSections.push({ id, title: '', body: '' })
      this.orderSync = [...this.flowSectionOrder, key]
      this.$set(this.expanded, key, false)
      this.$set(this.customTitleShowInput, key, false)
      this.$nextTick(() => {
        try {
          const root = this.$el
          const cards = root && root.querySelectorAll ? root.querySelectorAll('.biz-flow-card--custom') : []
          const last = cards && cards.length ? cards[cards.length - 1] : null
          if (last && last.scrollIntoView) last.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        } catch (e) {
          // ignore
        }
      })
    },
    clearFlowConfirmTitle(sectionKey) {
      if (Fsh.isRolePersonaSectionKey(sectionKey)) {
        return `确定清空「${this.getRolePersonaSectionTitle()}」模块内容吗？`
      }
      if (Fsh.isCustomFlowKey(sectionKey)) {
        const row = this.getCustomRow(sectionKey)
        const t = row && String(row.title || '').trim()
        return t ? `确定删除「${t}」吗？` : '确定删除该自定义内容模块吗？'
      }
      if (sectionKey === 'intentTag') {
        return '确定删除「意向标签」模块吗？'
      }
      const meta = FLOW_SECTION_META[sectionKey]
      const title = (meta && meta.title) || sectionKey
      return `确定删除「${title}」模块吗？`
    },
    intentRuleDeleteConfirmTitle(rule) {
      const n = rule && String(rule.name || '').trim()
      return n ? `确定删除意向「${n}」吗？` : '确定删除该条意向标签吗？'
    },
    executeClearFlowSection(sectionKey) {
      this.closeExclusiveConfirm('biz-section-' + sectionKey)
      if (Fsh.isRolePersonaSectionKey(sectionKey)) {
        this.form.roleName = ''
        this.form.roleDesc = ''
        ;(this.form.identities || []).forEach((item, i) => {
          if (item && typeof item === 'object') this.$set(item, 'active', i === 0)
        })
        ;(this.form.communicationStyles || []).forEach((item) => {
          if (item && typeof item === 'object') this.$set(item, 'active', false)
        })
        return
      }
      if (Fsh.isCustomFlowKey(sectionKey)) {
        const id = sectionKey.slice(CUSTOM_FLOW_PREFIX.length)
        const ci = this.customFlowSections.findIndex((c) => c.id === id)
        if (ci >= 0) this.customFlowSections.splice(ci, 1)
        const oi = this.flowSectionOrder.indexOf(sectionKey)
        if (oi >= 0) {
          const next = this.flowSectionOrder.slice()
          next.splice(oi, 1)
          this.orderSync = next
        }
        this.$delete(this.expanded, sectionKey)
        if (this.bizInputRefs[sectionKey]) this.$delete(this.bizInputRefs, sectionKey)
        this.$delete(this.customTitleShowInput, sectionKey)
        if (this.customTitleInputRefs[sectionKey]) this.$delete(this.customTitleInputRefs, sectionKey)
        return
      }
      const oi = this.flowSectionOrder.indexOf(sectionKey)
      if (oi >= 0) {
        const next = this.flowSectionOrder.slice()
        next.splice(oi, 1)
        this.orderSync = next
      }
      this.$delete(this.expanded, sectionKey)
      if (this.bizInputRefs[sectionKey]) this.$delete(this.bizInputRefs, sectionKey)
      if (this.fixedTitleInputRefs[sectionKey]) this.$delete(this.fixedTitleInputRefs, sectionKey)

      if (sectionKey === 'intentTag') {
        this.intentTag.rules = []
        return
      }

      this.$set(this.form, sectionKey, '')
      if (
        this.flowSectionTitles &&
        Object.prototype.hasOwnProperty.call(this.flowSectionTitles, sectionKey)
      ) {
        this.$delete(this.flowSectionTitles, sectionKey)
      }
    },
    addIntentRule() {
      const rules = Array.isArray(this.intentTag.rules) ? this.intentTag.rules : []
      rules.push({
        name: '',
        rule: '',
        ranking: rules.length + 1,
      })
    },
    removeIntentRule(index) {
      this.closeExclusiveConfirm('biz-intent-rule-' + index)
      this.intentTag.rules.splice(index, 1)
      this.intentTag.rules.forEach((rule, i) => {
        if (rule && typeof rule === 'object') {
          this.$set(rule, 'ranking', i + 1)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-pane-business {
  width: 100%;
}

.biz-flow-draggable {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.biz-flow-card {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.card-body-inner--role {
  padding: 0;

  ::v-deep .tab-pane-role .config-card {
    box-shadow: none;
    background: transparent;
  }
}
.biz-section-head {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 16px;
  border-bottom: 1px solid #f0f0f0;
  background-color: rgb(248 250 252 / 0.5);
}
.biz-section-drag-handle {
  cursor: grab;
  display: grid;
  grid-template-columns: repeat(2, 4px);
  grid-template-rows: repeat(3, 4px);
  gap: 0;
  flex-shrink: 0;
  padding: 2px 0;
  align-self: center;
  &:active {
    cursor: grabbing;
  }
}
.biz-section-drag-dot {
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background: #bfbfbf;
}
.biz-section-toggle-btn {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  justify-content: center;
  border-radius: 4px;
  color: #909399;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #e8ecf4;
    color: #515a6e;
  }

  ::v-deep .ivu-icon {
    font-size: 14px !important;
    line-height: 1;
  }
}
.biz-section-head--custom {
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;

  .biz-section-title-plain {
    flex: 1;
    min-width: 0;
    cursor: pointer;
  }

  .biz-section-actions {
    margin-left: auto;
  }

  .biz-custom-title-input {
    flex: 1;
    min-width: 0;
    max-width: none;
    cursor: text;
  }
  ::v-deep .biz-custom-title-input.ivu-input-wrapper {
    flex: 1;
    min-width: 0;
  }
  ::v-deep .biz-custom-title-input .ivu-input {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }
}
.biz-section-vdivider {
  width: 1px;
  height: 16px;
  background: #e8eaec;
  flex-shrink: 0;
}

.biz-flow-trash-trigger {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  outline: none;

  &:focus-visible {
    outline: none;
  }

  &--intent-rule {
    flex-shrink: 0;
  }
}
.biz-flow-card--custom {
  border: 1px solid #e8eaec;
}
.biz-custom-title-display {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  text-align: left;
  line-height: 32px;
  user-select: none;
  &.is-empty {
    color: #bfbfbf;
    font-weight: 400;
  }
}
.biz-fixed-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
}
.biz-fixed-title-inner {
  display: inline-flex;
  align-items: center;
  gap: 0;
  flex: 1;
  min-width: 0;
  user-select: none;
}
.biz-fixed-title-edit-zone {
  display: inline-flex;
  align-items: center;
  gap: 0;
  min-width: 0;
  cursor: pointer;
}
.biz-fixed-title-info-icon {
  flex-shrink: 0;
  margin-left: 8px;
  color: #8c8c8c;
  cursor: hand;
}
.biz-fixed-title-text {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.biz-title-with-edit {
  display: inline-flex;
  align-items: center;
  gap: 0;
}
.biz-title-text {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
.biz-title-edit-icon {
  flex-shrink: 0;
  margin-left: 8px;
  color: #2d8cf0;
  line-height: 1;
}
.biz-section-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.biz-section-icon-btn {
  cursor: pointer;
  color: #909399;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  &:hover {
    color: #515a6e;
  }
}
.biz-section-icon-btn--edit {
  width: 20px;
  height: 20px;
  justify-content: center;
  border-radius: 4px;
  color: #606266;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #e8ecf4;
    color: #262626;
  }
}
.biz-flow-ghost {
  opacity: 0.55;
}
.biz-flow-chosen .biz-section-drag-handle {
  cursor: grabbing;
}
.biz-flow-card .card-body-inner {
  border-radius: 8px;
  padding: 16px 20px;
  background: #fff;
}

.llm-flow-add-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 16px;
}
.llm-flow-add-btn {
  width: 100%;
  height: 40px !important;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 4px !important;
  background: #fafafa !important;
  color: #606266 !important;
  font-size: 13px !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 6px;
  &:hover {
    border-color: #4f6ef7 !important;
    color: #4f6ef7 !important;
    background-color: #f5f9ff !important;
  }
}

.llm-prompt-preview-card {
  margin-top: 0;
  border: 1px solid #e8eaec;
}
.llm-prompt-preview-head {
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.llm-prompt-preview-head-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  line-height: 32px;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: #262626;
  text-align: left;
}
.llm-prompt-preview-count {
  font-size: 13px;
  color: #8c8c8c;
  &.is-over {
    color: #ed4014;
    font-weight: 600;
  }
}
.llm-prompt-preview-body {
  padding: 12px 16px 16px;
  background: #fafafa;
}
.llm-prompt-preview-native {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #e8eaec;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.6;
  color: #262626;
  background: #f5f5f5;
  resize: vertical;
  min-height: 280px;
  &::placeholder {
    color: #bfbfbf;
  }
}

.config-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.form-row {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  &:last-child {
    margin-bottom: 0;
  }
}

.intent-rule-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.biz-flow-trash-trigger--intent-rule {
  margin-top: 4px;
}

.rp-insert-param-dropdown {
  flex-shrink: 0;
}
.rp-insert-param-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border: 1px solid #91d5ff !important;
  border-radius: 4px !important;
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-size: 14px !important;
  line-height: 26px !important;
  &:hover {
    border-color: #1890ff !important;
    color: #0050b3 !important;
    background: #bae7ff !important;
  }
}

.role-desc-guide {
  margin-bottom: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;

  &__bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    cursor: pointer;
    user-select: none;
    background: #f4f7fa;
  }
  &__bar-title {
    font-size: 14px;
    font-weight: 600;
    color: #262626;
  }
  &__toggle {
    font-size: 12px;
    color: #909399;
  }
  &__panel {
    padding: 16px;
    border-top: 1px solid #e4e7ed;
    background: #fafafa;
  }
  &__p {
    margin: 0 0 12px;
    font-size: 13px;
    color: #595959;
    line-height: 1.6;
    text-align: left;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &__label {
    display: inline;
    font-weight: 600;
    color: #262626;
  }
  &__p--pre {
    white-space: pre-line;
  }
}
</style>

<style lang="scss">
/* 插入参数下拉：transfer 挂到 body 时需全局样式 */
.rp-insert-param-transfer.ivu-select-dropdown {
  min-width: 200px;
}
.rp-insert-param-transfer .ivu-dropdown-menu {
  padding: 4px 0;
}
.rp-insert-param-transfer .ivu-dropdown-item.rp-insert-param-item {
  padding: 10px 14px !important;
  line-height: normal !important;
}
.rp-insert-param-transfer .rp-insert-param-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  min-width: 150px;
}
.rp-insert-param-transfer .rp-insert-param-row__label {
  font-size: 14px;
  color: #262626;
}
.rp-insert-param-transfer .rp-insert-param-row__token {
  font-size: 14px;
  color: #1890ff;
  flex-shrink: 0;
}

/* 开场白说明 Tooltip：transfer 到 body */
.biz-opening-tooltip.ivu-tooltip-popper .ivu-tooltip-inner {
  max-width: 490px !important;
  min-width: 260px;
  word-break: normal !important;
  overflow-wrap: break-word;
  line-height: 1.6;
}
</style>
